import VideoTranscripts from "../../common/videos/transcripts.js";

function init(){
    VideoTranscripts.init();
}

init();